/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export type SignedUrlID = string;

export class SignedUrl {
	fileId: string = ''

	url: string = ''
}